import React from "react"
import ReactDOM from "react-dom"
import EmployeeProfileComponent from "./employee-profile-component"

export default class EmployeeProfileModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.locale = (document.body && document.body.dataset.language) || "da"
    self.tabIcons = elem.dataset.tabIcons && JSON.parse(elem.dataset.tabIcons)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<EmployeeProfileComponent {...self.modelJson} locale={self.locale} />, self.elem)
  }
}
